var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "m11.4 1-1-1H6.6l-1 1H3v1H2C.9 2 0 2.9 0 4v18c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-1V1zM5 3h1.4l1-1h2.2l1 1H12v2H5zm10 1v18H2V4h1v3h11V4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M8.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M5 8H3v13h11v-2H5z"
  })));
};
export default SvgNote;